import { createSelector } from 'reselect'
import { propOr } from 'ramda'

const getGuruInsight = state => state.guruInsight

export const selectGuruInsight = createSelector(
  getGuruInsight,
  propOr(null, 'insight')
)

export const selectIsLoadingGuruInsight = createSelector(
  getGuruInsight,
  propOr(false, 'isLoading')
)

export const selectGuruInsightError = createSelector(
  getGuruInsight,
  propOr(null, 'error')
)
